import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {I18n, Translate} from 'react-redux-i18n';
import {EntityIllustration} from 'front-onceforall-core';
import ActionBar from '../../../layout/ActionBar';
import {getOrganisationLogoUrl} from '../../../utils/organisation';
import FavoriteRelationship from '../../favoriteRelationship';
import OrganisationDetails from '../../organisation/OrganisationDetails';
import {useClientDetailsStore} from '../ClientDetailsStore';

function HeaderView(props) {
  const organisation = useSelector(state => state.organisation);
  const {state: {client: {details}}} = useClientDetailsStore();

  return (
    <>
      <ActionBar
        showBackButton
        customUrl="/clients"
      >
        <div className="flex-container space-between py-2 w-100">
          <div className="flex-container">
            <EntityIllustration
              country={details.country}
              name={details.fullName}
              imageUrl={getOrganisationLogoUrl(details.organisationId)}
            />
            <div
              className="ml-5 clickable flex-container"
              tooltip={I18n.t(props.areDetailsShown ? 'action.collapseDetails' : 'action.expandDetails')}
              flow="right"
              data-id="toggleLink"
              onClick={props.onSwitchDetails}
            >
              <strong
                data-id="fullName"
                className="font-size-xl"
              >{details.fullName}</strong>
              <span
                className={`ml-3 ${props.areDetailsShown ? 'caret-raise' : 'caret-drop'}`}
                style={{height: 13, width: 13}}
              />
            </div>
            <div className="ml-5 flex-container">
              {!details.enabled &&
                <span
                  className="no-wrap chip"
                  data-id="organisation-deactivated"
                >
                  <Translate value="organisation.deactivated.title"/>
                </span>
              }
            </div>
          </div>
          <div>
            <FavoriteRelationship
              clientId={details.organisationId}
              subcontractorId={organisation.organisationId}
              organisationName={details.fullName}
            />
          </div>
        </div>
      </ActionBar>
      <OrganisationDetails
        organisation={details}
        isExpanded={props.areDetailsShown}
      />
    </>
  );
}

HeaderView.propTypes = {
  areDetailsShown: PropTypes.bool,
  onSwitchDetails: PropTypes.func.isRequired
};

export default HeaderView;
